import { Badge, BadgeProps } from '@mui/material'

type Props = BadgeProps

const HeaderBadge = ({ anchorOrigin, sx, ...props }: Props) => {
  return (
    <Badge
      anchorOrigin={anchorOrigin ?? { vertical: 'top', horizontal: 'right' }}
      sx={{
        '& .MuiBadge-badge': {
          transform: 'translate(4px, -4px)',
          height: 14,
          minWidth: 14,
          padding: '0 4px',
          fontSize: 10,
          lineHeight: '14px',
        },
        ...sx,
      }}
      {...props}
    />
  )
}

export default HeaderBadge
